// pages/index.js
import LandingPage from "@/pages/landing";
import { Metadata } from "next";

// Define metadata using Next.js 13+ app router syntax
export const metadata = {
  title:
    "Free Talent Assessment & AI Resume Builder | FreeTalentAssessment.com",
  description:
    "Discover your top talents with our free AI-driven platform. Chat with our AI for resume help, parse your CV, and get career advice at FreeTalentAssessment.com.",
  keywords:
    "free talent assessment, AI resume builder, resume parser, career advice, AI chatbot for resume help",
  openGraph: {
    title: "Free Talent Assessment & AI Resume Builder",
    description:
      "Uncover your strengths and chat with our AI for resume & career advice. FreeTalentAssessment.com has you covered.",
    images: ["https://freetalentassessment.com/fta_logo.png"],
    url: "https://freetalentassessment.com",
    type: "website",
  },
  twitter: {
    card: "summary_large_image",
    title: "Free Talent Assessment & AI Resume Builder",
    description:
      "Get personalized talent assessments, AI resume parsing, and career advice. Start free now.",
    images: ["https://freetalentassessment.com/fta_logo.png"],
  },
  robots: "index, follow",
};

// This enables SSR
export async function getServerSideProps() {
  const serverTime = new Date().toISOString();

  return {
    props: {
      serverTime,
    },
  };
}

export default function Home({ serverTime }) {
  return <LandingPage />;
}
